// Video hero — play button toggles mute/unmute
(function() {
  'use strict';

  function initVideoHero() {
    document.querySelectorAll('.video-hero__play-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var video = btn.closest('.video-hero__inner, .video-hero__split-media').querySelector('video');
        if (!video) return;
        if (video.muted) {
          video.muted = false;
          btn.setAttribute('aria-label', 'השתק');
        } else {
          video.muted = true;
          btn.setAttribute('aria-label', 'הפעל קול');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoHero);
  } else {
    initVideoHero();
  }
})();
